import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const fontWeightStandard = 'var(--fontWeightStandard, 400)'
import { Popup } from '@calendly/ui/components/popup'
import { CheckCircleIcon } from '@calendly/ui/components/icons'
import { TitleText } from '@calendly/ui/components/typography'

import PaymentSummary from 'components/payment/summary'
import { chargeSelector } from 'selectors/payment'
import { eventSelector } from 'selectors'
import { isReschedulingSelector } from 'selectors/current_invitee'
import { useI18n } from 'locales'
import _InnerPopup from "redirect-InnerPopup.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/redirect.js?styleId=InnerPopup";
import _Payment from "redirect-Payment.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/redirect.js?styleId=Payment";
import _CircleIconContainer from "redirect-CircleIconContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/redirect.js?styleId=CircleIconContainer";
import _RescheduledNotice from "redirect-RescheduledNotice.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/redirect.js?styleId=RescheduledNotice";
import _RedirectHint from "redirect-RedirectHint.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/redirect.js?styleId=RedirectHint";


const InnerPopup = /*#__PURE__*/styled('div', null, {
  displayName: "InnerPopup",
  styles: _InnerPopup
})

const Payment = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Payment",
  styles: _Payment
})

const CircleIconContainer = /*#__PURE__*/styled('div', null, {
  displayName: "CircleIconContainer",
  styles: _CircleIconContainer
})

const RescheduledNotice = /*#__PURE__*/styled('div', null, {
  displayName: "RescheduledNotice",
  styles: _RescheduledNotice
})

const RedirectHint = /*#__PURE__*/styled('h4', null, {
  displayName: "RedirectHint",
  styles: _RedirectHint
})

const ConfirmationRedirect = () => {
  const { i18n } = useI18n()
  const { publishers_list: publishersList } = useSelector(eventSelector)
  const charge = useSelector(chargeSelector)
  const isRescheduling = useSelector(isReschedulingSelector)

  const titleText = isRescheduling
    ? i18n.t('booking.templates.reschedule_confirmed_title')
    : i18n.t('booking.templates.confirmed_title')

  const noticeText = isRescheduling
    ? i18n.t('booking.templates.rescheduled_with', { name: publishersList })
    : i18n.t('booking.templates.scheduled_with', { name: publishersList })

  return (
    <Popup isOpen isBlocking onClose={() => {}}>
      <InnerPopup>
        <CircleIconContainer>
          <CheckCircleIcon 
            color={primaryColor} 
            width="57px" 
            height="57px" 
            inline={true}
          />
        </CircleIconContainer>
        <TitleText level={2} size="large">
          {titleText}
        </TitleText>
        <RescheduledNotice>
          {noticeText}
        </RescheduledNotice>
        <Payment charge={charge} />
        <RedirectHint>
          {i18n.t('booking.templates.redirecting')}
          {' ...'}
        </RedirectHint>
      </InnerPopup>
    </Popup>
  )
}

export default ConfirmationRedirect
